import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { AxiosError } from 'axios'

import showErrorToast from '@/common/utils/showErrorToast'
import useMutationCreateDepositPromotion from '@/modules/promotion/api/hooks/useMutateCreateDepositPromotion'
import { CreateDepositPromotionRequest } from '@/modules/promotion/type'
import DepositPromotionForm from '../../../DepositPromotionForm'
import { ProviderResolutionConflictDialog } from '../../../ProviderResolutionConflictDialog'

export default function CreateDepositPromotionForm() {
	const navigate = useNavigate()
	const [conflictDialogOpen, setConflictDialogOpen] = useState(false)
	const [conflictMessage, setConflictMessage] = useState('')

	const { mutate: createDepositPromotion } = useMutationCreateDepositPromotion({
		onSuccess: () => {
			toast.success('สร้างโปรโมชั่นสำเร็จ')
			navigate('/operator/deposit-promotion')
		},
		onError: (error) => {
			const axiosError = error as unknown as AxiosError<{
				message: string
				errorCode: string
			}>

			// Check if it's a provider resolution conflict error
			if (
				axiosError.isAxiosError &&
				axiosError.response?.data?.errorCode === 'PROVIDER_RESOLUTION_CONFLICT'
			) {
				setConflictMessage(axiosError.response.data.message)
				setConflictDialogOpen(true)
				return
			}

			// For other errors, show toast
			showErrorToast(error)
		},
	})

	const handleSubmit = (payload: CreateDepositPromotionRequest) => {
		createDepositPromotion({ payload })
	}

	return (
		<>
			<DepositPromotionForm mode="create" onSubmit={handleSubmit} />
			<ProviderResolutionConflictDialog
				isOpen={conflictDialogOpen}
				onClose={() => setConflictDialogOpen(false)}
				message={conflictMessage}
			/>
		</>
	)
}
